import { z } from 'zod'

export const supplierInstallationEmissionReportSpecificEmbeddedEmissionsMax = 99.99999
export const supplierInstallationEmissionReportSpecificEmbeddedEmissionsDecimalPlaces = 5
export const supplierInstallationEmissionReportSpecificEmbeddedEmissionsIntegerDigits = 2

const scale = 10 ** supplierInstallationEmissionReportSpecificEmbeddedEmissionsDecimalPlaces

export function isSupplierInstallationEmissionReportSpecificEmbeddedEmissionsValid(
  value: number
): boolean {
  if (!Number.isFinite(value) || value < 0) {
    return false
  }

  if (value > supplierInstallationEmissionReportSpecificEmbeddedEmissionsMax) {
    return false
  }

  return Math.abs(Math.round(value * scale) - value * scale) < 1e-6
}

export const supplierInstallationEmissionReportSpecificEmbeddedEmissionsSchema = z
  .number()
  .refine(isSupplierInstallationEmissionReportSpecificEmbeddedEmissionsValid, {
    message:
      'specificEmbeddedEmissions must be between 0 and 99.99999 with up to 5 decimal places',
  })
